import {
  Checkbox as MantineCheckbox,
  CheckboxProps as MantineCheckboxProps,
  type FloatingPosition,
} from '@mantine/core';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';
import { TextWithTooltip } from '../tooltip/TextWithTooltip';

import styles from './checkbox.module.scss';

export type CheckboxProps = {
  tooltipPosition?: FloatingPosition;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  /* default to 1 line visible, set to 0 to deactivate text truncation */
  labelLineClamp?: number;
} & Omit<MantineCheckboxProps, 'children' | 'onChange'>;

export function Checkbox({
  tooltipPosition = 'right',
  labelLineClamp = 1,
  onChange,
  ...props
}: CheckboxProps) {
  return (
    <MantineCheckbox
      {...props}
      onChange={(e) => onChange?.(e.target.checked)}
      classNames={{
        root: styles['root'],
        body: styles['body'],
        icon: styles['icon'],
        inner: styles['inner'],
        labelWrapper: styles['labelWrapper'],
        input: styles['input'],
        label: labelLineClamp === 0 ? undefined : styles['label--truncated'],
      }}
      label={
        props.label ? (
          <TextWithTooltip
            tooltipProps={{
              position: tooltipPosition,
              usePortal: false,
              width: '300px',
            }}
            textProps={{
              lineClamp: labelLineClamp === 0 ? undefined : labelLineClamp,
            }}
          >
            {props.label}
          </TextWithTooltip>
        ) : undefined
      }
      icon={({ indeterminate, ...iconProps }) => (
        <GoogleFontIcon
          name={indeterminate ? 'check_indeterminate_small' : 'check'}
          {...iconProps}
        />
      )}
    />
  );
}
